export function special_splash({compId,shapeHeight,animationSpeed,flipAnimation}) {
  animationSpeed = animationSpeed*2;
  let stdDeviation = 22,
      rectYmove = 60,
      gFilter = `filter="url(#blend_deep_${compId})"`,
      rectFilter = '';
  if('MozAppearance' in document.documentElement.style) {
    stdDeviation = 10;
    rectYmove = 50;
    rectFilter = gFilter;
    gFilter = '';
  }
  return `
  <filter id="blend_deep_${compId}" width="5" height="5">
    <feGaussianBlur in="SourceGraphic" stdDeviation="${stdDeviation}" result="blur" />
    <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 72 -23" result="blend_${compId}" />
    <feBlend in="SourceGraphic" in2="blend_${compId}" />
  </filter>
  <pattern class="patternSingle" id="single_${compId}" patternUnits="userSpaceOnUse" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="xMidYMax meet" width="1920" patternTransform="translate(0 0)">
  <g ${gFilter} transform="scale(0.5)" transform-origin="960 120">
  <rect y="180" x="-240" width="480" height="60"/>
   <rect y="180" x="240" width="480" height="60">
 <animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
 keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
 keyTimes="0;0.3;0.4;0.5;0.6;0.7;1"
 values="0 0;0 0;0 10;0 0;0 10;0 0;0 00">
     </animateTransform>
 </rect>
 <rect y="180" x="720" width="480" height="60">
 <animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
 keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
 keyTimes="0;0.27;0.37;0.47;0.57;0.67;0.77;1"
 values="0 0;0 0;0 ${rectYmove};0 20;0 30;0 10;0 00;0 00">
     </animateTransform>
 </rect>
   <rect y="180" x="1200" width="480" height="60">
 <animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
 keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
 keyTimes="0;0.3;0.4;0.5;0.6;0.7;1"
 values="0 0;0 0;0 10;0 0;0 10;0 0;0 00">
     </animateTransform>
 </rect>
 <rect y="180" x="1680" width="480" height="60"/>



<path class="st4" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.2;0.35;0.5;0.65;0.8;1"
values="0 200;-200 200;0 60;200 60;400 100;600 150;600 150">
    </animateTransform>
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="scale" additive="sum"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.25;0.5;0.75;1"
values="1 1;1 1;1 0.75;1 0.5; 1 0.25">
    </animateTransform>
</path>
  <path class="st4" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.35;0.5;0.65;0.75;1"
values="-200 200;-200 200;-200 60;0 110;200 130;600 210">
    </animateTransform>
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="scale" additive="sum"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.25;0.5;0.75;1"
values="1 1;1 0.75;1 0.5;1 0.25; 1 0">
    </animateTransform>
</path>
  <path class="st4" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.2;0.35;0.5;0.75;1"
values="300 200;100 100;300 75;500 125;700 175;1100 225">
    </animateTransform>
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="scale" additive="sum"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.25;0.5;0.75;1"
values="1 1;1 0.75;1 0.5;1 0.25; 1 0">
    </animateTransform>
</path>



<path class="st4" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.2;0.35;0.5;0.65;0.8;1"
values="-400 200;-400 200;-400 60;-600 60;-800 100;-1000 150;-1000 150">
    </animateTransform>
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="scale" additive="sum"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.25;0.5;0.75;1"
values="1 1;1 1;1 0.75;1 0.5; 1 0.25">
    </animateTransform>
</path>
  <path d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.35;0.5;0.65;0.8;1"
values="-200 200;-200 200;-200 60;-400 110;-600 140;-1000 200">
    </animateTransform>
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="scale" additive="sum"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.25;0.5;0.75;1"
values="1 1;1 0.75;1 0.5;1 0.25; 1 0">
    </animateTransform>
</path>
  <path class="st4" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.2;0.35;0.5;0.75;1"
values="-700 200;-400 100;-600 75;-800 125;-1200 175;-1200 225">
    </animateTransform>
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="scale" additive="sum"
keySplines="0 0 1 1;0 0 1 1;0 0 1 1;0 0 1 1"
keyTimes="0;0.25;0.5;0.75;1"
values="1 1;1 0.75;1 0.5;1 0.25; 1 0">
    </animateTransform>
</path>


<path class="after-wave-1" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0.12, 0, 0.39, 0;0.12, 0, 0.39, 0;0 0 1 1"
keyTimes="0;0.4;0.55;0.7;1"
values="-400 200;-400 100;-200 40;0 50;200 60">
    </animateTransform>
</path>
  <path class="after-wave-1" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0.12, 0, 0.39, 0;0.12, 0, 0.39, 0;0 0 1 1"
keyTimes="0;0.4;0.55;0.7;1"
values="0 200;0 100;-200 40;-400 50;-600 60">
    </animateTransform>
</path>
  <path class="after-wave-2" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0.12, 0, 0.39, 0;0.12, 0, 0.39, 0;0 0 1 1"
keyTimes="0;0.55;0.7;0.85;1"
values="-400 200;-400 100;-200 40;0 50;200 60">
    </animateTransform>
</path>
  <path class="after-wave-2" d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0 0 1 1;0.12, 0, 0.39, 0;0.12, 0, 0.39, 0;0 0 1 1"
keyTimes="0;0.55;0.7;0.85;1"
values="0 200;0 100;-200 40;-400 50;-600 60">
    </animateTransform>
</path>




<path d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0.22, 1, 0.36, 1;0.33, 1, 0.68, 1;0.12, 0, 0.39, 0;0.33, 1, 0.68, 1;0.12, 0, 0.39, 0;0 0 1 1"
keyTimes="0;0.35;0.55;0.7;.8;0.9;1"
values="-200 300;-200 200;-200 0;-200 150;-200 200;-200 200;-200 200">
    </animateTransform>
</path>
<g transform="translate(-75 0)">
<path d="M 1333 258 C 1255 334 951.3 291.7 986.2 256.8 L 1096.8 146.2 C 1131.7 111.3 1188.3 111.3 1223.2 146.2 L 1333.8 256.8 Z	">
<animateTransform attributeName="transform" attributeType="xml"  calcMode="spline" dur="${2 * animationSpeed}s" repeatCount="indefinite" type="translate"
keySplines="0.22, 1, 0.36, 1;0.33, 1, 0.68, 1;0.12, 0, 0.39, 0;0.33, 1, 0.68, 1;0.12, 0, 0.39, 0;0 0 1 1"
keyTimes="0;0.35;0.55;0.7;.8;0.9;1"
values="-200 300;-200 200;-200 0;-200 150;-200 200;-200 200;-200 200">
    </animateTransform>
</path>
</g>

<g transform="translate(-75 0)">
<circle cx="990" cy="240" r="25">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -140;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;-120 0;-120 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
    <animateTransform attributeType="xml" attributeName="transform" type="scale"
    values="1 1;1 1;0.8 0.8;0.8 0.8"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle cx="1020" cy="280" r="25">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -130;0 150;0 150"
    keyTimes="0;0.22;0.52;0.82;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;-100 0;-100 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
    <animateTransform attributeType="xml" attributeName="transform" type="scale"
    values="1 1;1 1;0.8 0.8;0.8 0.8"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>

<circle class="st8" cx="960" cy="240" r="15">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;200 0;200 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="1000" cy="220" r="18">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
</circle>
<circle class="st8" cx="1000" cy="220" r="15">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;-400 0;-400 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="960" cy="220" r="12">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -160;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;-450 0;-450 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="940" cy="220" r="12">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -170;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;-280 0;-280 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="960" cy="240" r="12">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1.9 * animationSpeed}s"
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;-200 0;-200 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    begin="${-1.9 * animationSpeed}s"
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="960" cy="240" r="15">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -180;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1.8 * animationSpeed}s"
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;-300 0;-300 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    begin="${-1.8 * animationSpeed}s"
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle cx="960" cy="240" r="22">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 20;0 -120;0 150;0 150"
    keyTimes="0;0.22;0.52;0.82;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;80 0;80 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
    <animateTransform attributeType="xml" attributeName="transform" type="scale"
    values="1 1;1 1;0.8 0.8;0.8 0.8"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle cx="960" cy="240" r="22">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 20;0 -195;0 150;0 150"
    keyTimes="0;0.22;0.52;0.82;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;-160 0;-160 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
    <animateTransform attributeType="xml" attributeName="transform" type="scale"
    values="1 1;1 1;0.8 0.8;0.8 0.8"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
</g>

<g transform="translate(75 0)">


<circle cx="1000" cy="240" r="22">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 -20;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;300 0;300 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle cx="960" cy="240" r="22">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 20;0 -195;0 150;0 150"
    keyTimes="0;0.22;0.52;0.82;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;440 0;440 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
    <animateTransform attributeType="xml" attributeName="transform" type="scale"
    values="1 1;1 1;0.8 0.8;0.8 0.8"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle cx="930" cy="240" r="25">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -140;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;420 0;420 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
    <animateTransform attributeType="xml" attributeName="transform" type="scale"
    values="1 1;1 1;0.8 0.8;0.8 0.8"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle cx="900" cy="280" r="25">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -130;0 150;0 150"
    keyTimes="0;0.22;0.52;0.82;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;400 0;400 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
    <animateTransform attributeType="xml" attributeName="transform" type="scale"
    values="1 1;1 1;0.8 0.8;0.8 0.8"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle cx="920" cy="240" r="22">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 -20;0 -218;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;150 0;150 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>


<circle class="st8" cx="960" cy="240" r="15">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;200 0;200 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="1000" cy="220" r="18">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
</circle>
<circle class="st8" cx="1000" cy="220" r="15">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;400 0;400 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="960" cy="220" r="12">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -190;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;500 0;500 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="960" cy="220" r="12">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -150;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;250 0;250 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="960" cy="240" r="12">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -200;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1.8 * animationSpeed}s"
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;200 0;200 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    begin="${-1.8 * animationSpeed}s"
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
<circle class="st8" cx="960" cy="240" r="15">
<animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;0 -180;0 150;0 150"
    keyTimes="0;0.2;0.5;0.8;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1.9 * animationSpeed}s"
    dur="${2 * animationSpeed}s" repeatCount="indefinite"/>
     <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 0;300 0;300 0"
    keyTimes="0;0.2;0.8;1"
    keySplines="0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
    begin="${-1.9 * animationSpeed}s"
    dur="${2 * animationSpeed}s" repeatCount="indefinite" additive="sum"/>
</circle>
</g>


</g>
      </pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
  <rect shape-rendering="crispEdges" style="transform: translate(${-((shapeHeight*8)/2+2560-2)}px,0)" class="animdiv-mask animdiv-mask-top" width="2560" y="${169*(shapeHeight/240)}" x="50%" height="${shapeHeight}" fill="white"></rect>
  <rect shape-rendering="crispEdges" style="transform: translate(${(shapeHeight*8)/2-2}px,0)" class="animdiv-mask animdiv-mask-top" width="2560" y="${169*(shapeHeight/240)}" x="50%" height="${shapeHeight}" fill="white"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})" ${rectFilter}></rect>
</mask>
`;
}